// HOIKU-1949のfacilityReserveを参照
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { GetUseReasonDto } from '../../../../dataAccess/webApi/dto/useReasonDto'
import { GetProjectDetailDto } from '../../../../dataAccess/webApi/dto/projectsDto'
import { 
  FacilityInfoType,
  ParentInfoType, 
  ChildLotteryReservationInfoType, 
  UsageDatetimeType, 
  CommonInput,
  IsCertificateUseReasonViewFlags
} from '../../lotteryReservation'

export interface LotteryReserveEntry {
  reservationNo?: string
  updateDatetime?: string
  
  useReasonCategory: string | null
  useReasonDetailCategory: string | null
  useReasonDetailDescription: string | null
  isUseReasonCategoryHidden: boolean

  /** 利用日時 */
  usageDatetimes: UsageDatetimeType[]

  /** 施設情報 */
  facility: FacilityInfoType

  /** 保護者情報 */
  parentInfo?: ParentInfoType
  
  /** お子様さま情報 + お子様別予約情報 */
  childInfoList: ( ChildLotteryReservationInfoType & { siblingsLotteryResultReferenceFlag?: string } )[]
  
  /** お子様共通予約情報 */
  commonInput?: CommonInput

  /** 利用目的マスタ情報 */
  useReason?: GetUseReasonDto

  /** 事業マスタ */
  projectMst?: GetProjectDetailDto

  /** 証明書情報に基づく利用目的の表示非表示の切り替え */
  isCertificateUseReasonViewFlags: IsCertificateUseReasonViewFlags
  /** 病気 */
  diagonosis?: {
    first: string | null,
    second: string | null
  }  
}

interface LotteryReserveState {
  entry?: LotteryReserveEntry
}

const initialState: LotteryReserveState = {}

export const lotteryReserveSlice = createSlice({
  name: 'lotteryReserve',
  initialState,
  reducers: {
    setLotteryReserve: (state, action: PayloadAction<LotteryReserveEntry>) => {
      state.entry = action.payload
    },
    clearLotteryReserve: (state) => {
      delete state.entry
    },
  },
})

export const { setLotteryReserve, clearLotteryReserve } = lotteryReserveSlice.actions
export const selectLotteryReserveEntry = (state: RootState) => state.lotteryReserve.entry
export default lotteryReserveSlice.reducer
